import './styles/SectionHeading.css';

export default function SectionHeading({ eyebrow, title, lead, headingId, isCentered = false, isInverted = false }) {
    const modifiers = [
        isCentered ? 'section-heading--centered' : '',
        isInverted ? 'section-heading--inverted' : '',
    ].join(' ');

    return (
        <header className={`section-heading ${modifiers}`.trim()}>
            {eyebrow && <p className="section-heading__eyebrow">{eyebrow}</p>}
            <h2 id={headingId} className="section-heading__title">{title}</h2>
            {lead && <p className="section-heading__lead">{lead}</p>}
        </header>
    );
}
